import { Injectable } from "@angular/core";

import { BehaviorSubject } from "rxjs";
import { JsonApiService } from "@app/core/services/json-api.service";
import { AngularFirestore } from "angularfire2/firestore";

import { first } from 'rxjs/operators';

const defaultUser = {
  username: "Guest"
}

@Injectable()
export class UserService {

  public user$ = new BehaviorSubject({...defaultUser});
  
  constructor(private afs: AngularFirestore) {
  }

  async getUserById(uid: string){
    try{
        let aux = await this.afs.collection("dealers", 
            ref => ref.where('uid', '==', uid))
                      .valueChanges().pipe(first()).toPromise().then(doc => {
                          return doc;
                      }).catch(error => {
                          throw error;
                      });
        if(aux.length==0)
            return {};
        return aux[0];
    }catch(error){
      console.error("Error getUserById", error);
      throw error;
    } 
  }
  

}
